
const mapTypesToExt = {
    'application/pdf': "pdf",
    'image/jpeg': "jpeg",
    'image/jpg': "jpg",
    'image/png': "png",
    'image/svg+xml': "svg",
    'image/tiff': "tiff",
    'image/avif': "avif",
    'image/webp': "webp",
    'image/vnd.microsoft.icon': "ico",
    'image/gif': "gif",
    'audio/mpeg': "mp3",
    'video/mp4': "mp4",
    'video/mpeg': "mpeg",
    'video/x-msvideo': "avi",
    'audio/wav': "wav",
    'audio/webm': "weba",
    'video/webm': "webm",
}

export function getExtByType(type) {
    return mapTypesToExt[type];
}

export function getTypeByExt(extension) {
    const lowercasedExtension = extension.toLowerCase(); // Normalize to lowercase
    return Object.keys(mapTypesToExt).find(key => mapTypesToExt[key] === lowercasedExtension)
}
export function typeSupport(type) {
    return mapTypesToExt[type];
    // Object.values(mapTypesToExt).includes(ext)
}

export function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const getFileTypeFromArrayBuffer = (arrayBuffer) => {
    const magicNumbers = {
        'application/pdf': [0x25, 0x50, 0x44, 0x46],
        'image/jpeg': [0xFF, 0xD8],
        'image/jpg': [0xFF, 0xD8],
        'image/png': [0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A],
        'image/svg+xml': [0x3C, 0x73, 0x76, 0x67],
        'image/tiff': [0x49, 0x49, 0x2A, 0x00],
        'image/avif': [0x00, 0x00, 0x00, 0x18, 0x41, 0x56, 0x49, 0x46],
        'image/webp': [0x52, 0x49, 0x46, 0x46],
        'image/vnd.microsoft.icon': [0x00, 0x00, 0x01, 0x00],
        'image/gif': [0x47, 0x49, 0x46, 0x38],
        'audio/mpeg': [0x49, 0x44, 0x33],
        'video/mp4': [0x66, 0x74, 0x79, 0x70, 0x6D, 0x70, 0x34, 0x32],
        'video/mpeg': [0x00, 0x00, 0x01, 0xBA],
        'video/x-msvideo': [0x52, 0x49, 0x46, 0x46],
        'audio/wav': [0x52, 0x49, 0x46, 0x46],
        'audio/webm': [0x1A, 0x45, 0xDF, 0xA3],
        'video/webm': [0x1A, 0x45, 0xDF, 0xA3],
        'text/html': [0x3C, 0x68, 0x74, 0x6D, 0x6C],
        // Add more magic numbers as needed
    };

    const uint8Array = new Uint8Array(arrayBuffer);

    for (const [type, signature] of Object.entries(magicNumbers)) {
        const matches = signature.every((byte, index) => byte === uint8Array[index]);
        if (matches) {
            return type;
        }
    }
    return null;
}

export const LESSONTYPESENUM = {
    SLC: "SLC"
}